var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoFiltered = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_filter_selected",
    transform: "translate(-421.928 -449.68)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54012",
    "data-name": "Path 54012",
    d: "M440.8,454.883a2.3,2.3,0,1,0,2.3,2.3A2.3,2.3,0,0,0,440.8,454.883Z",
    transform: "translate(1 -1.503)",
    fill: "#00AABE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54013",
    "data-name": "Path 54013",
    d: "M438.143,463.6a.911.911,0,0,1-.92.9h-8.644a.912.912,0,0,1-.92-.9h0v-.841a.911.911,0,0,1,.92-.9h8.644a.909.909,0,0,1,.92.9v0h0Zm-2.759,4.677a.911.911,0,0,1-.92.9h-3.127a.912.912,0,0,1-.92-.9h0v-.841a.911.911,0,0,1,.92-.9h3.126a.909.909,0,0,1,.92.9v0h0Zm2.115-11.1H425.82a.911.911,0,0,0-.92.9v.841a.912.912,0,0,0,.921.9H438.84A3.288,3.288,0,0,1,437.5,457.183Z",
    transform: "translate(1 -1.503)",
    fill: "#8d939c"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoFiltered);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_filtered.5043e1d570104f0bcd1d2411903246fd.svg";